import React from 'react';
import { TextFieldTelephone } from '@BICE_Vida/components';
import { FormGroup } from '../../designSystem/Form';
import TextField from '../../designSystem/TextField';
import { regExpAlphabetic } from '../../utils/constants';
import { formStepTexts } from '@/utils/generalTexts';

interface PersonalInfoFormProps {
  readonly personalInfoForm: {
    contactName: string;
    name: string;
    lastname: string;
    email: string;
    phone: string;
  };
  readonly formErrors: Record<string, { hasError: boolean; feedback: string }>;
  readonly handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  readonly handleKeyPress: (event: React.KeyboardEvent<HTMLInputElement>, regEx: RegExp) => void;
}

function PersonalInfoForm({
  personalInfoForm,
  formErrors,
  handleChange,
  handleBlur,
  handleKeyPress,
}: PersonalInfoFormProps) {
  return (
    <>
      <FormGroup>
        <TextField
          id="contactName"
          label={formStepTexts.inputContactName}
          value={personalInfoForm.contactName}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, regExpAlphabetic)}
          hasError={formErrors.contactName.hasError}
          feedback={formErrors.contactName.feedback}
          maxLength={50}
          type="text"
        />
      </FormGroup>
      <FormGroup>
        <TextField
          id="email"
          label={formStepTexts.inputEmail}
          value={personalInfoForm.email}
          onChange={handleChange}
          onBlur={handleBlur}
          hasError={formErrors.email.hasError}
          feedback={formErrors.email.feedback}
          type="email"
        />
      </FormGroup>
      <FormGroup>
        <TextFieldTelephone
          id="phone"
          label={formStepTexts.inputPhone}
          value={personalInfoForm.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          hasError={formErrors.phone.hasError}
          feedback={formErrors.phone.feedback}
          type="tel"
        />
      </FormGroup>
    </>
  );
}

export default PersonalInfoForm;
